import { render, staticRenderFns } from "./Queens.vue?vue&type=template&id=dd3ebdb6&scoped=true"
import script from "./Queens.vue?vue&type=script&lang=js"
export * from "./Queens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3ebdb6",
  null
  
)

export default component.exports